<template>
  <div
    v-if="reactions?.length"
    class="f-w"
  >
    <div
      v-for="(reaction, idx) in reactions"
      :key="`reacji-${idx}`"
      v-emoji="`:${reaction.emoji}:${reaction.count ? ' ' + reaction.count : ''}`"
      class="f-ac t-sm display p-hx1 p-v4 m-r bg-bg br-16"
    />
    <div
      v-if="showAddButton"
      class="f-ac p-hx1 p-v4 bg-bg br-16"
    >
      <i class="mi gray md-16">add_reaction</i>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    reactions: { type: Array, default: () => [] },
    showAddButton: { type: Boolean, default: true },
  });
</script>
